import {KeywordRuleType} from '../../../service/reviews/reviews-response-templates';

type AspectOptionType = {
    title: string;
    ids: Array<number>;
};

type ReviewConditionsFormValuesType = {
    attachmentsFilter?: string | null;
    keywordRules?: Array<KeywordRuleType>;
    autoTagTitles?: Array<string>;
};

type ReviewConditionsPayloadType = {
    reviewsAttachmentsFilter: string | null;
    reviewsKeywordRules: Array<KeywordRuleType>;
    reviewsAutoTagIds: Array<number> | null;
};

// Auto-tags are selected by aspect title in the UI but stored as a flat list of tag ids.
// These helpers translate between the two representations (AI-32).

export function mapKeywordRulesForSave(rawKeywordRules: Array<KeywordRuleType>): Array<KeywordRuleType> {
    return rawKeywordRules
        .map((keywordRule) => ({
            operator: keywordRule.operator,
            words: (keywordRule.words ?? []).map((word) => word.trim()).filter(Boolean),
        }))
        .filter((keywordRule) => keywordRule.words.length > 0);
}

export function aspectTitlesToIds(
    selectedTitles: Array<string>,
    aspects: ReadonlyArray<AspectOptionType>
): Array<number> {
    const titleToIds = new Map(aspects.map((aspect) => [aspect.title, aspect.ids]));

    return selectedTitles.flatMap((title) => titleToIds.get(title) ?? []);
}

export function aspectIdsToTitles(
    savedTagIds: Array<number> | null | undefined,
    aspects: ReadonlyArray<AspectOptionType>
): Array<string> {
    const savedIds = new Set(savedTagIds ?? []);

    return aspects.filter((aspect) => aspect.ids.some((tagId) => savedIds.has(tagId))).map((aspect) => aspect.title);
}

export function buildReviewConditionsPayload(
    values: ReviewConditionsFormValuesType,
    aspects: ReadonlyArray<AspectOptionType>
): ReviewConditionsPayloadType {
    const reviewsAutoTagIds = aspectTitlesToIds(values.autoTagTitles ?? [], aspects);

    return {
        reviewsAttachmentsFilter: values.attachmentsFilter || null,
        reviewsKeywordRules: mapKeywordRulesForSave(values.keywordRules ?? []),
        reviewsAutoTagIds: reviewsAutoTagIds.length > 0 ? reviewsAutoTagIds : null,
    };
}
